import { Mail, MapPin, Building2 } from "lucide-react";
import Seo from "@/components/site/Seo";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import PartnershipForm from "@/components/site/PartnershipForm";
import StayInLoop from "@/components/sections/StayInLoop";
import { IMG } from "@/lib/content";

export default function Contact() {
  return (
    <>
      <Seo title="Contact & Partnerships — RestPower" description="Partner with RestPower — real estate, EV infrastructure, energy, hospitality, fleet, brand, and investment inquiries welcome." path="/contact" />
      <PageHeader
        overline="Contact & Partnerships"
        title={<>Partner With RestPower.</>}
        intro="RestPower is currently in development. We're building the foundation for our first destination and exploring the partnerships, locations, and infrastructure required to bring the experience to life."
        image={IMG.developmentAerial}
        concept
      />

      <section className="bg-rp-bg" data-testid="contact-section">
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
          <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-4">
              <Reveal>
                <h2 className="font-display text-2xl font-medium tracking-tight text-white">Get in touch</h2>
                <p className="mt-4 text-sm leading-relaxed text-white/55">
                  Whether you're a landowner, energy provider, hospitality operator, fleet, brand, or
                  investor — we'd love to hear from you.
                </p>
                <div className="mt-8 space-y-4">
                  <a href="mailto:info@restpower.app" className="flex items-center gap-3 text-white/70 transition-colors hover:text-rp-accent" data-testid="contact-email">
                    <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/12 text-rp-accent"><Mail className="h-5 w-5" /></span>
                    <span className="font-mono text-sm">info@restpower.app</span>
                  </a>
                  <div className="flex items-center gap-3 text-white/70">
                    <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/12 text-rp-accent"><Building2 className="h-5 w-5" /></span>
                    <span className="font-mono text-sm">Early-stage · In development</span>
                  </div>
                  <div className="flex items-center gap-3 text-white/70">
                    <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/12 text-rp-accent"><MapPin className="h-5 w-5" /></span>
                    <span className="font-mono text-sm">restpower.app</span>
                  </div>
                </div>
              </Reveal>
            </div>

            <div className="lg:col-span-8">
              <Reveal delay={0.08} className="rounded-3xl border border-white/10 bg-rp-card p-7 md:p-10">
                <h3 className="font-display text-2xl font-medium tracking-tight text-white">Partnership Inquiry</h3>
                <p className="mt-2 text-sm text-white/50">Tell us a bit about the opportunity and we'll be in touch.</p>
                <div className="mt-8"><PartnershipForm /></div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <StayInLoop />
    </>
  );
}
